import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabsservicesnearme() {



const cardData = {
  keyword: "Cabs Services Near Me",
  heading: "Lotus Cab: Cabs Services Near Me in Pune",

  headingDescription:
    "Lotus Cab offers fast and reliable Cabs Services Near Me in Pune for local, airport, and outstation travel. Whether you need an urgent ride, daily commute taxi, corporate transfer, family pickup, or long-distance cab, we provide well-maintained AC sedan and SUV vehicles for comfortable journeys. Our professional chauffeurs ensure punctual pickup from your exact location with safe driving standards. Transparent pricing, instant booking confirmation, and 24/7 availability make us a trusted choice. With doorstep service across Pune city, Lotus Cab ensures your nearby taxi booking is quick, affordable, and completely stress-free.",

  top: "Top Places to Visit in Pune with Lotus Cab Near You",

  topPlaces: [
    {
      title: "Shaniwar Wada",
      description:
        "Shaniwar Wada is one of Pune’s most historic landmarks. Built during the Maratha Empire, it represents rich heritage and architecture. Visitors explore ancient gates and ruins. Evening light and sound show is popular. Ideal for history lovers and tourists. Easily accessible with nearby cab service."
    },
    {
      title: "Aga Khan Palace",
      description:
        "Aga Khan Palace is a significant monument in India’s freedom history. It features elegant architecture and peaceful gardens. Popular among cultural travelers. Ideal for sightseeing and photography. Located conveniently within city limits. Perfect destination with local cab booking."
    },
    {
      title: "Sinhagad Fort",
      description:
        "Sinhagad Fort offers scenic views and trekking experiences. Rich in Maratha history and bravery stories. Popular among adventure lovers. Ideal for sunrise visits. Located near Pune outskirts. Comfortable cab service makes travel easy."
    },
    {
      title: "Dagdusheth Ganpati Temple",
      description:
        "This temple is one of Pune’s most famous religious sites. Dedicated to Lord Ganesha, it attracts thousands of devotees. Centrally located in Pune city. Ideal for spiritual visits. Clean and organized temple premises. Easily reachable via local taxi."
    },
    {
      title: "Khadakwasla Dam",
      description:
        "Khadakwasla Dam offers scenic lake views and peaceful surroundings. Popular for sunset visits and family outings. Located a short drive from Pune. Ideal for weekend relaxation. Surrounded by greenery and hills. Comfortable cab ride makes access easy."
    },
    {
      title: "Parvati Hill",
      description:
        "Parvati Hill provides panoramic city views and spiritual experience. The temple complex attracts devotees. Ideal for short treks and sightseeing. Popular during sunrise and sunset. A historic landmark in Pune. Easily accessible with nearby cab service."
    },
    {
      title: "Phoenix Marketcity",
      description:
        "Phoenix Marketcity is a major shopping and entertainment hub. Offers branded stores and restaurants. Ideal for shopping and leisure. Air-conditioned comfort available. Popular among families and tourists. Convenient local cab access."
    },
    {
      title: "Osho International Meditation Resort",
      description:
        "Located in Koregaon Park, this resort attracts global visitors. Offers meditation and wellness programs. Peaceful and green environment. Ideal for relaxation and mindfulness. Popular among international travelers. Easy cab service access nearby."
    }
  ],

  services: [
    {
      name: "Taxi Near Me Pune",
      description:
        "Instant taxi service near your location in Pune with quick pickup and professional drivers. AC sedan and SUV options available. Transparent pricing policy maintained. Ideal for daily travel and urgent rides. 24/7 service support provided. Comfortable city travel guaranteed."
    },
    {
      name: "Local Cab Near Me",
      description:
        "Reliable local cab service near you for short-distance travel. Suitable for office commute and shopping trips. Clean and sanitized vehicles available. Affordable per-km pricing ensured. Flexible booking options provided. Safe city rides guaranteed."
    },
    {
      name: "Airport Taxi Near Me",
      description:
        "Quick airport taxi near your location for pickup and drop. Flight tracking support included. Timely arrival ensured. AC vehicles available. Transparent fare structure maintained. 24/7 airport transfer service."
    },
    {
      name: "Outstation Cab Near Me",
      description:
        "Book outstation cab near you for long-distance travel. Comfortable sedan and SUV fleet available. Professional highway drivers provided. Transparent pricing ensured. One-way and round-trip options available. Stress-free travel experience guaranteed."
    },
    {
      name: "24 Hours Cab Near Me",
      description:
        "Round-the-clock taxi service near your location. Suitable for late-night and early-morning travel. Safe and secure rides ensured. Professional drivers available anytime. Transparent pricing maintained. Reliable 24/7 travel support."
    },
    {
      name: "Corporate Cab Near Me Pune",
      description:
        "Professional corporate taxi service near your office location. Ideal for meetings and business travel. Timely pickup guaranteed. Clean and executive vehicles available. Transparent billing structure followed. Dependable service for corporate needs."
    },
    {
      name: "Family Taxi Near Me",
      description:
        "Spacious family taxi near your area with SUV options. Extra luggage space available. Comfortable seating ensured. Safe and smooth travel supported. Ideal for family outings and airport travel. Reliable service guaranteed."
    },
    {
      name: "Online Cab Booking Near Me",
      description:
        "Easy online booking for nearby cab service with instant confirmation. Secure payment options available. Flexible pickup scheduling supported. Transparent pricing shared before confirmation. 24/7 support team available. Hassle-free booking process."
    }
  ],

  tableData: [
    ["Cabs Services Near Me in Pune", "Taxi Near Me Pune"],
    ["Local Cab Near Me", "Airport Taxi Near Me"],
    ["Outstation Cab Near Me", "Affordable Taxi Near Me Pune"],
    ["24 Hours Cab Near Me", "Online Cab Booking Near Me"],
    ["Corporate Cab Near Me Pune", "Family Taxi Near Me"],
    ["AC Cab Near Me Pune", "SUV Taxi Near Me"],
    ["Sedan Cab Near Me", "Instant Cab Near Me"],
    ["Reliable Cab Near Me Pune", "Best Taxi Service Near Me"]
  ],

  whychoose: [
    {
      WhyChooseheading: "Quick Pickup Near Your Location",
      WhyChoosedescription:
        "Fast response and immediate pickup from your exact address in Pune."
    },
    {
      WhyChooseheading: "Transparent Pricing",
      WhyChoosedescription:
        "Clear and honest fare structure with no hidden charges."
    },
    {
      WhyChooseheading: "24/7 Availability",
      WhyChoosedescription:
        "Round-the-clock taxi service for any urgent travel need."
    },
    {
      WhyChooseheading: "Professional Chauffeurs",
      WhyChoosedescription:
        "Experienced and courteous drivers ensure safe rides."
    },
    {
      WhyChooseheading: "Well-Maintained AC Fleet",
      WhyChoosedescription:
        "Clean and regularly serviced sedan and SUV vehicles."
    },
    {
      WhyChooseheading: "Corporate & Family Friendly",
      WhyChoosedescription:
        "Suitable for business travel and family outings."
    },
    {
      WhyChooseheading: "Online Instant Booking",
      WhyChoosedescription:
        "Easy booking with instant confirmation and flexible scheduling."
    },
    {
      WhyChooseheading: "Reliable Citywide Service",
      WhyChoosedescription:
        "Coverage across all major Pune locations."
    }
  ]
};

const faqData = [
  { question: "How fast can I get a cab near me?", answer: "Pickup time usually ranges between 10 to 20 minutes depending on location." },
  { question: "Is airport taxi near me available 24/7?", answer: "Yes, airport taxi service is available round the clock." },
  { question: "Are vehicles AC?", answer: "Yes, AC sedan and SUV options are available." },
  { question: "Can I book outstation cab near me?", answer: "Yes, outstation taxi service is available from your location." },
  { question: "Is online booking available?", answer: "Yes, online booking with instant confirmation is supported." },
  { question: "Are drivers verified?", answer: "Yes, all drivers are background-verified and trained." },
  { question: "Can I book SUV near me?", answer: "Yes, SUV taxi options are available for family and group travel." },
  { question: "Is night taxi available?", answer: "Yes, 24/7 taxi service including night rides is available." },
  { question: "Do you provide corporate cab service?", answer: "Yes, corporate taxi service is available near your office." },
  { question: "Are fares transparent?", answer: "Yes, transparent pricing with clear billing is maintained." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Kulkarni",
    feedback:
      "Needed urgent cab near my location and Lotus Cab arrived within minutes. Clean vehicle and professional driver. Very reliable service.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Sharma",
    feedback:
      "Booked airport taxi near me and the service was punctual. Transparent pricing and smooth ride made it stress-free.",
    rating: 5
  },
  {
    id: 3,
    name: "Mr. Akash Patil",
    feedback:
      "Corporate cab near office was handled professionally. On-time pickup and comfortable ride. Highly recommended.",
    rating: 5
  }
];

































































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cabs Services Near Me",
  "image": "https://lotuscab.com/assets/images/cabs-services-near-me.jpg", 
  "description": "Lotus Cab provides reliable cab services near you in Pune, including local, airport, outstation, and corporate taxis. Book affordable sedan, SUV, and AC cabs with instant online booking for family trips, business travel, and 24/7 availability, ensuring safe and comfortable journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5900"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "99",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/cabs-services-near-me"
  }
};





  return (
    <div>
      

<Helmet>
  <title>Contact: +91 8767592195 | Cabs Services Near Me | Lotus Cab</title>
  <meta 
    name="description" 
    content="Book cab services near you in Pune with Lotus Cab. Affordable local, airport, outstation & corporate taxis with sedan, SUV & AC options. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Cabs Services Near Me in Pune, Taxi Near Me Pune, Local Cab Near Me, Airport Taxi Near Me, Outstation Cab Near Me, Affordable Taxi Near Me Pune, 24 Hours Cab Near Me, Online Cab Booking Near Me, Corporate Cab Near Me Pune, Family Taxi Near Me, AC Cab Near Me Pune, SUV Taxi Near Me, Sedan Cab Near Me, Instant Cab Near Me, Reliable Cab Near Me Pune, Best Taxi Service Near Me" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/30.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabsservicesnearme;